import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { makeGetTask } from '../../../reduxes/slices/tasks/selectors'
import { TimelineType } from '../../../types/models'
import { Task } from '../../tasks/task'
import Timeline from '../timeline'

type Props = {
  timeline: TimelineType
}
export const TaskTimeline = ({ timeline, ...props }: Props) => {
  const getTask = useMemo(makeGetTask, [])
  const task = useSelector((state) => getTask(state, timeline?.tl_id))

  return (
    <Timeline
      timeline={timeline}
      item={task}
      handle={timeline.handle}
      {...props}
    >
      {task && <Task task={task} />}
    </Timeline>
  )
}
